/**
 * This function does nothing, useful as a fallback value
 */
export const noOp = (): undefined => undefined;

/**
 * Same as `noOp` but asynchronous for the case where the required function resolves to a `Promise`
 */
export const noOpAsync = async (): Promise<undefined> => undefined;
